import { useCallback } from 'react';
import AnalyticsService from 'services/AnalyticsService';

const useAnalytics = () => {
  const analytics = useCallback(new AnalyticsService(), []);

  return analytics;
};

export default useAnalytics;
